import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Grid, Typography, Button, Divider, Card, CardMedia } from "@material-ui/core";
import '../../App.css'
import './who-styles.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import whoClasses from './whoStyles.js'
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Data from './data.js';
import {FiArrowLeftCircle, FiArrowRightCircle} from 'react-icons/fi';

  

const classes = {
    viewButtonLabel: { height: '100%' },
    MuiDialogContent:
    {
        width: '1500px',
    },
};

const App = () => {
  const globalClasses = globalUseStyles();
  const whoStyles = whoClasses();
  const [open, setOpen] = React.useState(false);
  const [selectedProfile, setSelectedProfile] = useState(true);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const showPrev = (e) => {
    e.stopPropagation();
    let currentIndex = Data.indexOf(selectedProfile);
    if (currentIndex <= 0) {
      setOpen(false);
    } else {
      let nextImage = Data[currentIndex - 1];
      setSelectedProfile(nextImage);
    }
  };


  const showNext = (e) => {
    e.stopPropagation();
    let currentIndex = Data.indexOf(selectedProfile);
    if (currentIndex >= Data.length - 1) {
      setOpen(false);
    } else {
      let nextImage = Data[currentIndex + 1];
      setSelectedProfile(nextImage);
    }
  };

  return (
    <ThemeProvider theme={theme}>
        <Container className={"whoExpertiseStyle"} maxWidth={false} component="section">
            <Container className={"whoExpertiseStyleInner"} maxWidth={false} component="section">
                <Grid className={globalClasses.containerTopPaddingLg} container>
                    <Grid className={globalClasses.containerSmall} container >
                    <Grid item xs={12} md={12}  >
                        <Typography align="center"  variant="subtitle1">Our Leadership</Typography>
                        <Typography  align="center" variant="h2">Expertise across multiple disciplines</Typography>
                    </Grid>
                    </Grid>
            <Grid className={globalClasses.containerSmall} container >
                <Grid item md={12} container spacing={3}>
                {Data.map(bio => (
                        <Grid  item xs={12} sm={6} md={4} container>
                        <Button onClick={() => {
                setSelectedProfile(bio);
                handleClickOpen(true);
                        }} className={whoStyles.expertiseButton}
                        classes={{ label: whoStyles.viewButtonLabel }}
                        >
                        <Card style={{height: '100%'}} className={globalClasses.fullWidth}>
                        <div className={'fullWidthCard'}>
                                    <CardMedia
                                    alt=""
                                    component="img"
                                    image={bio.img}
                                     className={globalClasses.fullWidth}
                                    />
                                    <div className={whoStyles.expertise}>
                                        <div className={whoStyles.expertiseInner}>
                                    <Typography variant="body1" className={globalClasses.noMarginBold}>{bio.name}</Typography>
                                    <Typography variant="body2" className={whoStyles.expertiseInnerMargin}>{bio.title}</Typography>
                                    </div>
                                    </div>
                                    </div>
                                </Card>
                          </Button>
                        </Grid>
                              ))}
  <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='lg'
     >
    <FiArrowLeftCircle className={whoStyles.leftArrow} onClick={showPrev}/>
    <FiArrowRightCircle className={whoStyles.rightArrow}  onClick={showNext}/>            
    <DialogContent maxWidth='lg' className={classes.content}>
   
    <Grid container >

        <Grid item xs={10}  >
            <h3>Our Team</h3>
            </Grid>
        <Grid item xs={2}>
            <div className={whoStyles.closeButton}>
                <IconButton aria-label="close" align="right" onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </div>
        </Grid>
        </Grid>
        <Divider/>        
        <Grid container className={whoStyles.modalInner}>
            <Grid item xs={12} sm={4} md={3}  >
                <img src={selectedProfile.img} className={globalClasses.thumbImg} alt=''/>
                <Typography variant ="h4" className={globalClasses.bold} >{selectedProfile.name}</Typography>
                <Typography variant ="body2" className={whoStyles.title}>{selectedProfile.title}</Typography>
            </Grid>
            <Grid className={whoStyles.modalPadding} item xs={12} sm={8} md={9}>
                <Typography variant ="body2">{selectedProfile.desc}</Typography>  
                     </Grid>
            </Grid>
        </DialogContent>
        </Dialog>
                    </Grid>
                </Grid>
            </Grid>
            </Container>
        </Container>
    </ThemeProvider>

  );
};




export default App;